import { Component, inject, Input } from '@angular/core';
import { PlantInfoData } from '../../models/detailed-info';
import { ProductService } from '../../service/product.service';
import { NGXLogger } from 'ngx-logger';
import { DetailInfoType, TabItem, arcticBatteryTab, arcticOnePhaseGridTab, arcticOnePhaseLoadTab, arcticSolarTab, arcticThreePhaseGridTab, arcticThreePhaseLoadTab, batteryTab, gridTab, loadTab, optimusBatteryTab, optimusGridTab, optimusLoadTab, solarTab } from '../../models/enum';
import { CommonModule } from '@angular/common';
import { InverterType, PlantTypeEnum } from '../../models/stats';

import { ClickableDirective } from '../../directives/clickable.directive';

@Component({
    selector: 'app-detailed-info',
    imports: [CommonModule, ClickableDirective],
    templateUrl: './detailed-info.component.html',
    styleUrl: './detailed-info.component.scss'
})
export class DetailedInfoComponent  {

  selectedTab: DetailInfoType = DetailInfoType.LOAD;
  detailInfoType = DetailInfoType;
  plantType = PlantTypeEnum;
  @Input() modelName?: string;
  @Input() dataLoggerSN?: string;
  @Input() plantID?: string;
  @Input() inverterType?: string;
  @Input() phaseType?:number;
  detailedInfo!: PlantInfoData|undefined;
  productService = inject(ProductService);
  public logger: NGXLogger = inject(NGXLogger);
  isOpen: boolean = false;
  selectedPlantType!: string;
  loadTab: TabItem[] = loadTab;
  solarTab: TabItem[] = solarTab;
  gridTab: TabItem[] = gridTab;
  batteryTab: TabItem[] = batteryTab;
  optimusInverterLoadTab: TabItem[] = optimusLoadTab;
  optimusInverterGridTab: TabItem[] = optimusGridTab;
  optimusInverterBatteryTab: TabItem[] = optimusBatteryTab;
  arcticOnePhaseLoadTab:TabItem[]=arcticOnePhaseLoadTab;
  arcticThreePhaseLoadTab:TabItem[]=arcticThreePhaseLoadTab;
  arcticSolarTab:TabItem[]=arcticSolarTab;
  arcticOnePhaseGridTab:TabItem[]=arcticOnePhaseGridTab;
  arcticThreePhaseGridTab:TabItem[]=arcticThreePhaseGridTab;
  arcticBatteryTab:TabItem[]=arcticBatteryTab;
  selectedBatteryKey!: keyof PlantInfoData;
  filteredBatteryTab!: TabItem[];
  inverterTypeDetail = InverterType;

    getDisplayedBatteryKey() {
  if (!this.detailedInfo) return;
 
  const charging = Number(this.detailedInfo.batteryChargingCurrent || 0);
  const discharging = Number(this.detailedInfo.batteryDischargingCurrent || 0);
 
  const isCharging = charging >= discharging;
 
  this.selectedBatteryKey = isCharging
    ? 'batteryChargingCurrent'
    : 'batteryDischargingCurrent';
  const batterySource =
    this.inverterType === this.inverterTypeDetail.OPTIMUS_3P
      ? this.optimusInverterBatteryTab
      : this.batteryTab;
 
  this.filteredBatteryTab = batterySource.filter(
    t =>
      t.key !==
      (isCharging
        ? 'batteryDischargingCurrent'
        : 'batteryChargingCurrent')
  );
}
 
 
  getDetailInfo() {
    this.productService.getDetailedInfo(this.plantID).subscribe({
      next: (DetailedInfoResponse) => {
        this.detailedInfo = DetailedInfoResponse.data
        this.getDisplayedBatteryKey()
      }, error: (err) => {
        this.logger.error(err)

      }
    })
  }
  toggle(plantType: string): void {
    this.selectedPlantType = plantType
    this.isOpen = !this.isOpen;
    if (this.isOpen) {
      this.selectedTab = DetailInfoType.LOAD;
      this.getDetailInfo();
    }
  }
  parameterSelected(parameterSelected: string) {
    switch (parameterSelected) {
      case 'load':
        this.selectedTab = DetailInfoType.LOAD
        break;
      case 'solar':
        this.selectedTab = DetailInfoType.SOLAR
        break;
      case 'grid':
        this.selectedTab = DetailInfoType.GRID
        break;
      case 'battery':
        this.selectedTab = DetailInfoType.BATTERY
        break;

    }
  }

  
}
